import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15cebfba&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=15cebfba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cebfba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15cebfba')) {
      api.createRecord('15cebfba', component.options)
    } else {
      api.reload('15cebfba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=15cebfba&scoped=true&", function () {
      api.rerender('15cebfba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/DevProjectLayout/sidebar/index.vue"
export default component.exports